import { Table } from 'mixs/base/table_mixin';
import ReadController from 'mixs/notifications/read-controller';
import {
  NOTIFICATION_READ
} from 'apps/events';
export class  NotificationTable extends Table {
  readController: ReadController;
  init(){
    super.init();
    this.readController = ReadController.getInstance();
    window.addEventListener(NOTIFICATION_READ, (e) => { this.onRead(e) })
  }
  onRead(e){
    let ids = e.detail;
    this.readController.onRead(ids);
  }
}
riot.mixin('notifications.table', NotificationTable as riot.TagMixin)
